export default {
  palette: {
    primary: '#01a1c3',
    highlight: '#01a1c3',
    black: '#000000',
    red: '#df0026',
    blue: '#01a1c3',
    purple: '#6f64f8',
    green: '#17c400',
    yellow: '#ffa550',
    grey: '#606060',
    lightGrey: '#999999',
    darkGrey: '#14161f',
    orange: '#da532c',
    white: '#fff',
    pink: '#d808dd',
    border: '#d6d6d6',
    textGrey: '#959caf',
  },
  layout: {
    sideMenu: 250,
    sideBar: 420,
  },
  fonts: {
    SFProTextRegular: 'SFProText-Regular',
    SFProTextMedium: 'SFProText-Medium',
    SFProTextBold: 'SFProText-Bold',
    SFProTextSemibold: 'SFProText-Semibold',
    SFProTextLight: 'SFProText-Light',
    SFUITextRegular: 'SFUIText-Regular',
    SFUITextMedium: 'SFUIText-Medium',
    SFProDisplayBlackItalic: 'SFProDisplay-BlackItalic',
  },
};
